// @flow
import { useContext } from 'react';
// $FlowFixMe
import { VideoContext, IVideoContext } from '../VideoProvider/index';

export default function useVideoContext(): IVideoContext {
  const context = useContext(VideoContext);
  if (!context) {
    throw new Error('useVideoContext must be used within a VideoProvider');
  }
  return context;
}
